import React, { useState, useEffect } from 'react'
import * as JsSearch from 'js-search'
import { CardsSection, SearchBar } from '../components'
import Layout from '../templates/layout'
import useCourses from '../hooks/useCourses'
import { useLocation } from '@reach/router'
import useHome from '../hooks/useHome'
import ReusableFilterSelect from '../templates/ReusableFilterSelect'
import { Helmet } from 'react-helmet'

const AcademicOffer = () => {
  const dataCourses = useCourses()
  const fjsCourses = dataCourses?.allStrapiFjsCourses.nodes

  const [queryResults, setQueryResults] = useState(fjsCourses)
  const [search, setSearch] = useState(null)

  // --- Datos para filtros dinámicos (igual que en Header) ---
  const homeData = useHome() // <-- Obtener datos de useHome
  const interestAreas =
    homeData?.allStrapiHomeFjs?.nodes[0]?.interestArea?.interest_areas || []
  const trainingTypesData =
    homeData?.allStrapiHomeFjs?.nodes[0]?.navbar?.typesOfTraining
      ?.training_types || []

  // Formatear para ReusableFilterSelect (si es necesario)
  const areasConocimientoOptions = interestAreas.map((area) => ({
    key: area.slug,
    label: area.title
  }))

  const categoriasCursosOptions = trainingTypesData.map((type) => ({
    key: type.slug,
    label: type.title
  }))
  // ---------------------------------------------------------

  //guardamos los datos del head y los tomamos para reutilizar en el filtro
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  
  const areaFilter = params.get('area')
  const unidadFilter = params.get('unidad')
  const categoriaFilter = params.get('categoria')
  const modalidadFilter = params.get('modalidad')
  const microcredencialesFilter = (params.get('microcredenciales') || '')
  const MICRO_FILTER_AMBAS = 'todas'
  
  const [selectedFilters, setSelectedFilters] = useState({
    area: areaFilter || '',
    unidad: unidadFilter || '',
    categoria: categoriaFilter || '',
    modalidad: modalidadFilter || '',
    microcredenciales: microcredencialesFilter || ''
  })
  // Agregar esta función slugify al inicio del componente
  const slugify = (value = '') =>
    value
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')

  const termFrequency = true
  const selectedSanitizer = 'Lower Case'
  const removeStopWords = true
  
  //Filtra el textArea duration de schedule
  const filterSchedule = (schedule) => {

    const text = (schedule || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

    const regexPresencial = /\bpresencial(es)?\b/;
    const regexHibrido = /\bhibrid(o|os|a|as)?\b/;
    const regexVirtual = /\b(virtual(es)?|a\s?distancia|on\s?line|en\s?linea|remoto(s)?)\b/;

    switch (selectedFilters.modalidad) {
      case 'presencial':
        return !regexHibrido.test(text) && !regexVirtual.test(text) && regexPresencial.test(text);
      
      case 'hibrido':        
        return regexHibrido.test(text) || (regexPresencial.test(text) && regexVirtual.test(text))
    
      case 'a-distancia':
        return !regexHibrido.test(text) && !regexPresencial.test(text) && regexVirtual.test(text)
  
      default:
        return false;
    }  
  }
 
  // Actualizar solo la parte de unidades en filterCourses
  const filterCourses = (courses) => {
    return courses.filter((course) => {
      // Área (interest_areas.slug)
      const matchesArea =
        !selectedFilters.area ||
        course.interest_areas?.some(
          (area) => area.slug === selectedFilters.area
        )

      // Unidad (academic_unit.name) - CORREGIDO
      const matchesUnidad =
        !selectedFilters.unidad ||
        slugify(course.academic_unit?.name) === selectedFilters.unidad

      // Categoría (training_type.slug)
      const matchesCategoria =
        !selectedFilters.categoria ||
        course.training_type?.slug === selectedFilters.categoria


      // Modalidad (features.schedule.duration)

      const matchesModalidad = 
        !selectedFilters.modalidad ||
        filterSchedule(course.features.schedule.duration)

      // Microcredencial (microcredential_type)
      const matchesMicro = !selectedFilters.microcredenciales
        ? true
        : selectedFilters.microcredenciales === MICRO_FILTER_AMBAS
        ? course.microcredential_type === 'HABILITA_MICROCREDENCIAL' ||
          course.microcredential_type === 'ES_MICROCREDENCIAL'
        : course.microcredential_type === selectedFilters.microcredenciales

      return (
        matchesArea &&
        matchesUnidad &&
        matchesCategoria &&
        matchesModalidad &&
        matchesMicro
      )
    })
  }

  const filteredCourses = filterCourses(
    queryResults.length ? queryResults : fjsCourses
  )

  const newCourses = filteredCourses.filter(
    (course) => course.dateStart >= new Date().toISOString()
  )

  const expiredCourses = filteredCourses
    .filter((course) => course.dateStart < new Date().toISOString())
    .reverse()

  //Fin de la extraccion y retulizacion de datos
  const rebuildIndex = () => {
    const dataToSearch = new JsSearch.Search('name')

    if (removeStopWords) {
      dataToSearch.tokenizer = new JsSearch.StopWordsTokenizer(
        dataToSearch.tokenizer
      )
    }

    dataToSearch.indexStrategy = new JsSearch.AllSubstringsIndexStrategy()

    selectedSanitizer === 'Case Sensitive'
      ? (dataToSearch.sanitizer = new JsSearch.CaseSensitiveSanitizer())
      : (dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer())
    termFrequency === true
      ? (dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex('name'))
      : (dataToSearch.searchIndex = new JsSearch.UnorderedSearchIndex())

    dataToSearch.addIndex('name')
    dataToSearch.addIndex(['training_type', 'title'])
    dataToSearch.addIndex(['academic_unit', 'name'])
    dataToSearch.addIndex(['seo', 'pageKeywords'])
    dataToSearch.addIndex('idSIUCC')
    dataToSearch.addDocuments(fjsCourses) // adds the data to be searched
    setSearch(dataToSearch)
  }

  const handleSearch = (textInput) => {
    textInput.length === 0
      ? setQueryResults(fjsCourses)
      : setQueryResults(search.search(textInput))
    textInput.length === 0
  }

  useEffect(() => {
    rebuildIndex()
  }, [])

  useEffect(() => {
    // Cuando cambian los filtros seleccionados, re-aplicamos el filtrado
    // Esto también se dispara al inicio con los valores de la URL
    const coursesToFilter = fjsCourses // Siempre empezamos con todos los cursos
    const filtered = filterCourses(coursesToFilter)
    setQueryResults(filtered) // Actualizamos los resultados filtrados
  }, [selectedFilters, fjsCourses]) // Dependencias: selectedFilters y fjsCourses

  // ... (tu useEffect de rebuildIndex)
  useEffect(() => {
    rebuildIndex()
  }, [fjsCourses])

  // AcademicOffer.js
  const unidadesOptions = [
    { key: 'ciencias-agropecuarias', label: 'Agronomía y Veterinaria' },
    { key: 'arquitectura-y-diseno', label: 'Arquitectura'  },
    { key: 'ciencias-de-la-salud', label: 'Ciencias de la Salud' },
    {
      key: 'ciencias-economicas-y-de-administracion',
      label: 'Ciencias Económicas'
    },
     {
      key: 'ciencia-politica-y-relaciones-internacionales',
      label: 'Ciencias Políticas'
    },
    { key: 'ciencias-quimicas', label: 'Ciencias Químicas' },
    {
      key: 'derecho-y-ciencias-sociales',
      label: 'Derecho'
    },
     { key: 'educacion', label: 'Educación' },
    { key: 'escuela-de-posgrado', label: 'Escuela de Posgrado' },
    { key: 'filosofia-y-humanidades', label: 'Filosofía' },
    { key: 'ingenieria', label: 'Ingeniería' },
    { key: 'teologia', label: 'Teología' },
    { key: 'universidad', label: 'Universidad' },
  ]

    const modalidadesOptions = [
    { key: 'presencial', label: 'Presencial' },
    { key: 'a-distancia', label: 'A Distancia' },
    { key: 'hibrido', label: 'Híbrido'  },
  ]

    const microcredencialesOptions = [
    { key: 'ES_MICROCREDENCIAL', label: 'Es microcredencial' },
    { key: 'HABILITA_MICROCREDENCIAL', label: 'Aplica a microcredencial' },
    { key: 'todas', label: 'Todas' }
  ]
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    setSelectedFilters({
      area: params.get('area') || '',
      unidad: params.get('unidad') || '',
      categoria: params.get('categoria') || '',
      modalidad: params.get('modalidad') || '',
      microcredenciales: (params.get('microcredenciales') || '')
    })
  }, [location.search])
  return (
    <Layout>
      <Helmet>
        <title>Oferta Académica | FJS</title>
      </Helmet>
      <SearchBar
        onQuery={handleSearch}
        placeholder={'Buscá tu curso por nombre, temática o unidad académica'}
      />
      {/* --- FILTROS  --- */}
      <div className="container mt-4">
        <div className="row align-items-end">
          <div className="col-sm-6 col-md-3 mb-3 ">
            <ReusableFilterSelect
              label="Área de conocimiento"
              options={areasConocimientoOptions}
              selectedValues={
                selectedFilters.area ? [selectedFilters.area] : []
              }
              onChange={(values) => {
                const newValue =
                  values.length > 0 ? values[values.length - 1] : ''
                setSelectedFilters({
                  ...selectedFilters,
                  area: newValue
                })
              }}
              valueKey="key"
              labelKey="label"
              simpleValues={false}
              customWidth={280}
            />
          </div>
          <div className="col-sm-6 col-md-3 mb-3">
            <ReusableFilterSelect
              label="Categoría de cursos"
              options={categoriasCursosOptions}
              selectedValues={
                selectedFilters.categoria ? [selectedFilters.categoria] : []
              }
              onChange={(values) => {
                const newValue =
                  values.length > 0 ? values[values.length - 1] : ''
                setSelectedFilters({
                  ...selectedFilters,
                  categoria: newValue
                })
              }}
              valueKey="key"
              labelKey="label"
              simpleValues={false}
              customWidth={280}
            />
          </div>
          <div className="col-sm-6 col-md-3 mb-3">
            <ReusableFilterSelect
              label="Unidad académica"
              options={unidadesOptions}
              selectedValues={
                selectedFilters.unidad ? [selectedFilters.unidad] : []
              }
              onChange={(values) => {
                const newValue =
                  values.length > 0 ? values[values.length - 1] : ''
                setSelectedFilters({
                  ...selectedFilters,
                  unidad: newValue
                })
              }}
              valueKey="key"
              labelKey="label"
              simpleValues={false}
              customWidth={280}
            />
          </div>
          <div className="col-sm-6 col-md-3 mb-3">
            <ReusableFilterSelect
              label="Modalidad de cursado"
              options={modalidadesOptions}
              selectedValues={
                selectedFilters.modalidad ? [selectedFilters.modalidad] : []
              }
              onChange={(values) => {
                const newValue =
                  values.length > 0 ? values[values.length - 1] : ''
                setSelectedFilters({
                  ...selectedFilters,
                  modalidad: newValue
                })
              }}
              valueKey="key"
              labelKey="label"
              simpleValues={false}
              customWidth={280}
            />
          </div>
          <div className="col-sm-6 col-md-3 mb-3">
            <ReusableFilterSelect
              label="Tipo de microcredencial"
              options={microcredencialesOptions}
              selectedValues={
                selectedFilters.microcredenciales ? [selectedFilters.microcredenciales] : []
              }
              onChange={(values) => {
                const newValue =
                  values.length > 0 ? values[values.length - 1] : ''
                setSelectedFilters({
                  ...selectedFilters,
                  microcredenciales: newValue
                })
              }}
              valueKey="key"
              labelKey="label"
              simpleValues={false}
              customWidth={280}
            />
          </div>
          <div className="col-3 mb-3 d-flex">
            <button
              className={`btn btn-outline-secondary ${
                selectedFilters.area ||
                selectedFilters.categoria ||
                selectedFilters.unidad ||
                selectedFilters.modalidad ||
                selectedFilters.microcredenciales
                  ? ''
                  : 'invisible'
              } `}
              onClick={() =>
                setSelectedFilters({...selectedFilters,  area: '', unidad: '', categoria: '', modalidad: '', microcredenciales: ''} )
              }
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>
      {/* ---  FILTROS --- */}
      <CardsSection courses={newCourses} areas={true} id={'courses'} />
      {expiredCourses.length > 0 && (
        <CardsSection
          courses={expiredCourses}
          related={true}
          title={'Cursos comenzados'}
          id={'cursos_comenzados'}
        />
      )}
    </Layout>
  )
}

export default AcademicOffer
